module.exports = __webpack_public_path__ + "img/character1.8261eae6.png";